import { Container, Stack } from "@mantine/core"
import { ErrorBox, Loader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { CertificateVerificationModal } from "~/pages/Brand/Certificates/components/CertificateVerificationModal"
import { CertificatesFilters } from "~/pages/Brand/Certificates/components/CertificatesFilters"
import { CertificatesList } from "~/pages/Brand/Certificates/components/CertificatesList"
import { CertificatesTableHeaders } from "~/pages/Brand/Certificates/components/CertificatesTableHeaders"
import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

export const CertificatesTable = () => {
  const { t } = useTranslation("common")

  const {
    isLoading,
    isError,
    error,
    selectedCertificateInfo,
    setSelectedCertificateInfo,
  } = useCertificatesTableContext()

  if (isError) {
    return (
      <Container mt="5%" w="100%" h="100%">
        <ErrorBox title={t("dataLoad.error.title")} error={error} />
      </Container>
    )
  }

  if (isLoading) return <Loader fullPage />

  return (
    <Stack>
      <Stack justify="space-between">
        <CertificatesTableHeaders />
        <CertificatesFilters />
      </Stack>
      <CertificatesList />
      {selectedCertificateInfo && (
        <CertificateVerificationModal
          certificate={selectedCertificateInfo}
          onClose={() => setSelectedCertificateInfo(null)}
          opened={!!selectedCertificateInfo}
        />
      )}
    </Stack>
  )
}
